import React from 'react';
import { PASSWORD_RULES, checkPasswordRules } from '../../utils/passwordValidation';

export default function PasswordRequirements({ password }) {
  const results = checkPasswordRules(password);

  return (
    <div aria-live="polite" style={styles.wrap}>
      <ul style={styles.list}>
        {PASSWORD_RULES.map((rule) => {
          const met = results[rule.key];
          return (
            <li key={rule.key} style={{ ...styles.item, color: met ? '#00D4A0' : '#6B7FA8' }}>
              <span style={styles.icon} aria-hidden="true">{met ? '✓' : '○'}</span>
              {rule.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const styles = {
  wrap: {
    background: '#0A0F1E',
    border: '1px solid #1E2D4A',
    borderRadius: '8px',
    padding: '10px 12px',
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '12px',
    fontFamily: 'inherit',
    transition: 'color 0.15s ease',
  },
  icon: {
    fontSize: '12px',
    width: '14px',
    textAlign: 'center',
    flexShrink: 0,
  },
};
